module.exports = __webpack_public_path__ + "img/ilifestyle_screen02.b14d769d.png";